









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ITextLengthValidatable } from "../../../../domain/document/items";

@Component({
})
export default class TextValidateLengthViewer extends Mixins() {
  @Prop()
  source: ITextLengthValidatable;

  get textLength(): number {
    return this.source && this.source.getTextLength
      ? this.source.getTextLength()
      : 0;
  }

  get lengthChecklength(): number {
    return this.source && this.source.lengthChecklength
      ? this.source.lengthChecklength
      : 0;
  }
}
